<template>
    <div class="outsourcing-batch-import-dialog-upload-file-view">
        <div class="batch-dialog-layout">
            <div class="instruction-panel">
                <el-steps direction="vertical" :active="4">
                    <el-step
                        title="下載 Excel 範本"
                        description=""
                    >
                        <template slot="description">
                            <div>預設五種身份可選：<br/>老闆、財務、專案經理、員工、自訂</div>
                        </template>
                    </el-step>
                    <el-step
                        title="輸入資料"
                        description=""
                    />
                    <el-step
                        title="上傳 Excel 批次建立帳號"
                        description=""
                    />
                    <el-step title="調整權限">
                        <template slot="description">
                            逐一按“編輯”檢視帳號權限，<br/>依該員工職責自行增減。
                        </template>
                    </el-step>
                </el-steps>
            </div>
            <div class="action-panel">
                <div><el-button type="primary" plain style="width: 100%;" @click="onDownloadExample">下載 Excel 範本</el-button></div>
                <div v-if="!isQR()"><el-button type="primary" class="upload-file-btn" @click="onUploadSheet">上傳 Excel 資料</el-button></div>
                <div><el-button @click="$emit('close')">取消</el-button></div>
                <a v-show="false" ref="ExampleLink" :href="`/download/${downloadFileName}v${downloadFileVersion}.xlsx`" download style="margin-left: 10px;">下載範本</a>
                <input v-show="false" ref="fileInput" type="file" accept=".csv,.xlsx" @change="onFileInputChange" />
            </div>
        </div>
    </div>
</template>

<script>
import XLSX from 'xlsx';

export default {
    data() {
        return {
            downloadFileVersion: 1,
        };
    },
    computed: {
        downloadFileName() {
            return '帳號匯入範例';
        },
    },
    methods: {
        onUploadSheet() {
            this.$refs.fileInput.click();
        },
        onDownloadExample() {
            this.$refs.ExampleLink.click();
        },
        onFileInputChange(event) {
            if (!event.target.files[0]) return;

            const inputFile = event.target.files[0];
            const reader = new FileReader();

            reader.onload = (e) => {
                try {
                    const wb = XLSX.read(e.target.result, { type: 'binary' });

                    // eslint-disable-next-line no-throw-literal
                    if (!wb.Sheets['匯入資料']) throw { msg: '無效的檔案，請檢查後重新上傳' };

                    this.$emit('updateSheet', XLSX.utils.sheet_to_json(wb.Sheets['匯入資料']));
                    this.$emit('updateFileName', event.target.files[0].name);
                } catch (err) {
                    this.$message({
                        showClose: true,
                        message: err.msg,
                        type: 'error',
                    });
                }
            };

            reader.readAsArrayBuffer(inputFile);
        },
    },
};
</script>

<style lang="scss">
.outsourcing-batch-import-dialog-upload-file-view {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 10px;
    > div {
        width: 260px;
        display: flex;
        justify-content: space-between;
        &:first-child {
            // margin-bottom: 20px;
        }
    }
    .upload-file-btn {
        width: 100%;
    }

    .batch-dialog-layout {
        display: grid;
        grid-template-columns: 380px 1fr;
        width: 100%;
    }
    .action-panel {
        padding: 30px;
        display: flex;
        flex-direction: column;
        gap: 10px;
    }
    .instruction-panel {
        background-color: #eee;
        border-bottom-left-radius: 10px;
        height: 450px;
        padding: 50px 50px;

        .el-step__title.is-finish {
            font-size: 11.5pt;
            margin-bottom: 5px;
        }
        .el-step__description.is-finish {
            color: #666;
            line-height: 150%;
            font-size: 10pt;
            margin-bottom: 20px;
        }
    }
}
</style>
